export default {
    
    data() {
        return {
            isTrustpilotWidgetEnabled: false,
            observer: null,
        }
    },

    methods: {
        initiObserver(target) {
            let vm = this;

            this.observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList') {
                        vm.isTrustpilotWidgetEnabled = true;
                    }
                });
            });

            this.observer.observe(
                document.getElementById(target), 
                { childList: true }
            );
        },
    },

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
};